import React from 'react';
import AnalyticsPageLayout from '../components/analytics/AnalyticsPageLayout';
import SponsoredCohortFinalProjects from '../components/SponsoredCohortFinalProjects';
import SponsoredCohortCertificatesIssued from '../components/SponsoredCohortCertificatesIssued';

const TABS = [
  {
    title: 'Submitted final projects',
    component: <SponsoredCohortFinalProjects />,
  },
  {
    title: 'Certificates issued',
    component: <SponsoredCohortCertificatesIssued />,
  },
];

export default function CohortCertificationAnalytics() {
  return (
    <AnalyticsPageLayout
      title="Cohort Certification Analytics"
      description="Submitted final projects and learners approved for certification."
      tabs={TABS}
    />
  );
}
